import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ReactionVoteNoIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <circle cx="8" cy="8" fill="#E55951" r="8" />
    <path
      d="M9.90461 4.50458C10.344 4.06524 11.0561 4.06524 11.4954 4.50458C11.9348 4.94392 11.9348 5.65606 11.4954 6.0954L9.59085 7.99999L11.4954 9.90458L11.5728 9.98984C11.9332 10.4317 11.9073 11.0835 11.4954 11.4954C11.0835 11.9073 10.4317 11.9332 9.98987 11.5727L9.90461 11.4954L8.00003 9.59082L6.09544 11.4954C5.6561 11.9347 4.94395 11.9347 4.50461 11.4954C4.06527 11.0561 4.06527 10.3439 4.50461 9.90458L6.4092 7.99999L4.50461 6.0954C4.06528 5.65606 4.06528 4.94392 4.50461 4.50458C4.94395 4.06524 5.6561 4.06524 6.09544 4.50458L8.00003 6.40917L9.90461 4.50458Z"
      fill="white"
    />
  </svg>
);
